import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';

export function useLogOutGoogleAuth() {
  const qc = useQueryClient();

  return useMutation(
    async (data: any) => {
      const res = await $api.post(endPoints.GOOGLE_AUTH_LOGOUT, data);

      return res.data;
    },
    {
      onSuccess: async res => {
        await qc.invalidateQueries([queryKeys.GOOGLE_AUTH_LOGOUT]);

        showMessage(res.message, res.accept);
      },
      onError: baseErrorHandler
    }
  );
}

export function usePostTelegramAdd() {
  const qc = useQueryClient();

  return useMutation(
    async (data: {}) => {
      const res = await $api.post(endPoints.POST_TELEGRAM_ADD, data);

      return res.data;
    },
    {
      onSuccess: async res => {
        await qc.invalidateQueries([queryKeys.POST_TELEGRAM_ADD]);
        await qc.invalidateQueries([queryKeys.ISHAVE_TELEGRAM]);

        window.open(res?.data, '_blank');

        showMessage(res.message, res.accept);
      },
      onError: baseErrorHandler
    }
  );
}

export function useDeleteTelegramRemove() {
  const qc = useQueryClient();

  return useMutation(
    async (data: {}) => {
      const res = await $api.delete(endPoints.DELETE_TELEGRAM_REMOVE, data);

      return res.data;
    },
    {
      onSuccess: res => {
        qc.invalidateQueries([queryKeys.DELETE_TELEGRAM_REMOVE]);
        showMessage(res.message, res.accept);
      },
      onError: baseErrorHandler
    }
  );
}
